import { render, staticRenderFns } from "./ReferenciasPrincipal.vue?vue&type=template&id=42e51184&"
import script from "./ReferenciasPrincipal.vue?vue&type=script&lang=js&"
export * from "./ReferenciasPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports